export function useShare() {
  const runtimeConfig = useRuntimeConfig()
  const { isWebview } = useWebviewBridge()
  const isShareModelOpen = useState('shareModal', () => false)
  const { $t } = useNuxtApp()
  const { locale } = useI18n()

  const shareImage = computed(() => {
    if (locale.value === 'ko') {
      return `${runtimeConfig.public.appDomain}/images/open_graph_heavenlymotherslove_ko.jpg`
    }
    return `${runtimeConfig.public.appDomain}/images/open_graph_heavenlymotherslove_en.jpg`
  })

  useHead({
    script: [
      {
        src: 'https://t1.kakaocdn.net/kakao_js_sdk/2.1.0/kakao.min.js',
        integrity: 'sha384-dpu02ieKC6NUeKFoGMOKz6102CLEWi9+5RQjWSV0ikYSFFd8M3Wp2reIcquJOemx',
        crossorigin: 'anonymous',
      },
    ],
  })

  function toggleShareBox() {
    isShareModelOpen.value = !isShareModelOpen.value
  }

  function shareFacebook(shareUrl: string) {
    const url = `http://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
    if (isWebview.value) {
      useWebviewBridge().launchUrl(url)
    }
    else {
      window.open(url, 'x-share-dialog', 'width=626,height=436')
    }
  }

  function shareX(shareUrl: string) {
    const xUrl = `https://x.com/intent/tweet?url=${shareUrl}`

    if (isWebview.value) {
      useWebviewBridge().launchUrl(xUrl)
    }
    else {
      window.open(xUrl, 'x-share-dialog', 'width=626,height=436')
    }
  }

  function shareEmail(shareUrl: string, title: string) {
    location.href = `mailto:?subject=${title}&amp&body=${shareUrl}`
  }

  function shareLine(shareUrl: string) {
    const url = `http://line.me/R/msg/text/?${shareUrl}`
    window.open(url, '_blank')
  }

  function shareKakao(shareUrl: string) {
    const kakao = (window as any).Kakao

    if (!kakao.isInitialized()) {
      kakao.init('8bc47f566db10278b5fe59f7fb77a40b')
    }

    kakao.Story.open({
      url: shareUrl,
      text: '',
    })
  }

  function shareSMS(shareUrl: string) {
    const url = `sms:?&body=${shareUrl}`
    if (isWebview.value) {
      useWebviewBridge().launchUrl(url)
    }
    else {
      location.href = url
    }
  }

  function shareKakaoTalk(shareUrl: string, title: string, description: string, imageUrl: string) {
    if (isWebview.value) {
      useWebviewBridge().shareWithKakaoTalk({
        description,
        imageUrl,
        linkUrl: shareUrl,
        title,
      })
      return
    }

    const kakao = (window as any).Kakao

    if (!kakao.isInitialized()) {
      kakao.init('8bc47f566db10278b5fe59f7fb77a40b')
    }

    kakao.Share.sendDefault({
      objectType: 'feed',
      content: {
        title,
        description,
        imageUrl,
        link: {
          mobileWebUrl: shareUrl,
          webUrl: shareUrl,
        },
        imageHeight: 630,
        imageWidth: 1200,
      },
      buttons: [
        {
          title: $t('참여하기'),
          link: {
            mobileWebUrl: shareUrl,
            webUrl: shareUrl,
          },
        },
      ],
    })
  }

  async function copyURL(shareUrl: string) {
    await window.navigator.clipboard.writeText(shareUrl)
  }

  function shareWhatsApp(shareUrl: string) {
    const message = encodeURIComponent(shareUrl)
    const whatsappUrl = `whatsapp://send?text=${message}`
    window.open(whatsappUrl, '_blank')
  }

  function shareFacebookMessenger(shareUrl: string) {
    const messengerUrl = `fb-messenger://share?link=${encodeURIComponent(shareUrl)}`
    window.open(messengerUrl, '_blank')
  }

  return {
    shareFacebook,
    shareX,
    shareEmail,
    shareLine,
    shareKakao,
    shareSMS,
    shareKakaoTalk,
    shareWhatsApp,
    shareFacebookMessenger,
    copyURL,
    isShareModelOpen,
    toggleShareBox,
    shareImage,
  }
}
